export default __webpack_public_path__ + "assets/47168d325c2f6f8363a2e31c5cd1f539.woff2";